import './meeting.less';

class MeetingController {
    static get $inject() {
        return ['meetingShared', 'systemInfo'];
    }

    constructor(meetingShared, systemInfo) {
        this.meeting = meetingShared.meeting;
        this.systemInfo = systemInfo;
    }
}

angular.module("tromanWeb").controller('MeetingController', MeetingController);
